export default {
  0: { label: "테스트페이지"},
  53: { label: "사고조사 보고서", isApproval: true },
  54: { label: "사고경위서" },
  55: { label: "목격자 진술서" },
  56: { label: "실험실 안전사고 보고", isApproval: true },
  57: { label: "산업재해조사표" },
  58: { label: "산업안전보건위원회" },
  59: { label: "안전경영위원회" },
  60: { label: "안전근로협의체" },
  61: { label: "안전보건협의체" },
  62: { label: "아차사고 사례 카드" },
  63: { label: "아차사고 사례 개선 확인 카드" },
  64: { label: "실험실 일상 점검표" },
  65: { label: "실험실 정기 점검표" },
  66: { label: "TAC 안전관리 점검표" },
  67: { label: "밀폐공간 작업프로그램 평가표" },
  68: { label: "밀폐공간 작업 전 체크리스트" },
  69: { label: "고압가스 충전실 안전점검표" },
  70: { label: "한수단 2호 안전점검표" },
  71: { label: "잠수 운용 계획서" },
  72: { label: "잠수작업 전 안전점검표" },
  73: { label: "잠수 운용 결과서" },
  74: { label: "중량물·운반기계 안전점검표", isApproval: true },
  75: { label: "작업장 안전점검표", isApproval: true },
  76: { label: "안전", isApproval: true },
  77: { label: "보건", isApproval: true },
  78: { label: "공단임직원", useListGetCompanyName: true },
  79: { label: "하도급업체 근로자", useListGetCompanyName: true },
  80: { label: "공단임직원" },
  81: { label: "하도급업체 근로자" },
  82: { label: "정기 위험성 평가", isApproval: true },
  83: { label: "수시 위험성 평가", isApproval: true },
  84: { label: "작업수행부서", isApproval: true },
  85: { label: "하도급업체", isApproval: true },
  86: { label: "안전·보건예산 현황", isApproval: true, useHeaderDate: true },
  87: { label: "기타", useListGetCompanyName: true },
  88: { label: "기타" },
  89: { label: "현장 정보", usePrint: false },

  100: { label: "합동 안전점검", isApproval: false, usePrint: true, hidePrintTitle: true },
  101: { label: "안전보건 경영방침", isApproval: false, usePrint: true },
  102: { label: "안전보건총괄책임자 업무 수행평가", isApproval: false, usePrint: true },
  103: { label: "현장(직접수행)  관리", isApproval: true, usePrint: true },
  104: { label: "하도급업체 정보", isApproval: false, usePrint: true },
  105: { label: "하도급업체 등록", isApproval: false, usePrint: true, hideFileDownload: true },
  106: { label: "안전보건 관련 예산 (내·용·위)", isApproval: true, usePrint: true, useHeaderDate: true },
  107: { label: "안전·보건교육", isApproval: false, usePrint: true, hidePrintTitle: true, usePrevPost: true },
  108: { label: "안전보건", isApproval: true, usePrint: true },
  109: { label: "안전보건 경영방침", isApproval: true, usePrint: true },
  110: { label: "도로 보수", isApproval: true, usePrint: true },
  111: { label: "현장(안전보건 관련 예산(시설물 유지))", isApproval: true, usePrint: true },
  112: { label: "건설현장 일반관리", isApproval: false, usePrint: true, hidePrintTitle: true },
  113: { label: "수영장", isApproval: false, usePrint: true },
  114: { label: "시설물 점검", isApproval: true, usePrint: true },
  115: { label: "시설물 관리", isApproval: true, usePrint: true },
  116: { label: "(재해발생) 산업재해 발생 시 보고 절차 안내", isApproval: false, usePrint: true },
  117: { label: "산업재해조사표", isApproval: false, usePrint: true, hidePrintTitle: true },
  118: { label: "계약정보", isApproval: true, usePrint: true },

  119: { label: "안전보건총괄책임자 선임", isApproval: true, usePrint: true },
  120: { label: "안전보건책임자 선임", isApproval: true, usePrint: true },
  121: { label: "안전보건조정자 선임", isApproval: true, usePrint: true },
  122: { label: "안전보건관리자 및 산업보건의 선임", isApproval: true, usePrint: true },
  123: { label: "안전보건관리자 및 산업보건의(건설업) 선임", isApproval: true, usePrint: true },
  124: { label: "안전보건담당자 선임", isApproval: true, usePrint: true },
  125: { label: "관리감독자 선임", isApproval: true, usePrint: true },
  126: { label: "안전보건 조직 체계도", isApproval: false, usePrint: true, hidePrintTitle: true },

  127: { label: "안전보건관리책임자 업무 수행평가", isApproval: false, usePrint: true },
  128: { label: "관리감독자 업무 수행평가", isApproval: false, usePrint: true },
  129: { label: "종사자 참여 평가", isApproval: false, usePrint: true },
  130: { label: "하도급업체 수행평가", isApproval: false, usePrint: true },
  131: { label: "수시 점검표", isApproval: false, usePrint: true },

  132: { label: "교육 모니터링", isApproval: true, usePrint: true },
  133: { label: "월별 보고", isApproval: true, usePrint: true },
  134: { label: "반기별 보고", isApproval: false, usePrint: true },

  135: { label: "하도급업체 정보", isApproval: true, usePrint: true },
  136: { label: "안전보건 점검 인력", isApproval: true, usePrint: true },
  137: { label: "안전보건 점검 계획", isApproval: false, usePrint: true, listType: "list137" },
  138: { label: "비상 연락/지원 체계도", isApproval: true, usePrint: true },
  139: { label: "유관기관 비상연락망", isApproval: false, usePrint: true, hidePrintTitle: true },
  140: { label: "안전보건관리체계 구축 현황", isApproval: false, usePrint: true },
  141: { label: "안전보건 조직도", isApproval: true, usePrint: true },
  142: { label: "내부종사자 정보", isApproval: false, usePrint: true },

  143: { label: "하도급전 정보 제공", isApproval: true, usePrint: true },
  144: { label: "기본안전보건대장", isApproval: true, usePrint: true },
  145: { label: "설계안전보건대장", isApproval: true, usePrint: true },
  146: { label: "공사안전보건대장", isApproval: false, usePrint: true, usePrintTitle: false, usePrevPost: true },
  147: { label: "설계변경 요청", isApproval: true, usePrint: true },
  148: { label: "건설공사 기간 연장", isApproval: true, usePrint: true },
  149: { label: "수급인 산재예방 평가", isApproval: true, usePrint: true },
  150: { label: "안전보건 확보 의무", isApproval: false, usePrint: true },
  151: { label: "위험성평가협의회", isApproval: true, usePrint: true },
  152: { label: "산업안전보건위원회", isApproval: false, usePrint: true, usePrevPost: true },
  153: { label: "노사협의체", isApproval: false, usePrint: true, usePrevPost: true },

  154: { label: "안전보건 관련 예산(도급·발주)", isApproval: true, usePrint: true, useHeaderDate: true },
  155: { label: "안전보건 관련 예산(시설물 유지)", isApproval: true, usePrint: true, useHeaderDate: true },

  156: { label: "근로자 의견 청취", isApproval: true, usePrint: true },
  157: { label: "안전보건자료", isApproval: false, usePrint: true },
  158: { label: "위험요인 파악", isApproval: false, usePrint: true },
  159: { label: "현장 순회", isApproval: false, usePrint: true },
  160: { label: "유해·위험요인 점검(개선)사항 요청", isApproval: true, usePrint: true },

  161: { label: "정기 위험성평가", isApproval: false, usePrint: true, usePrevPost: true, printDirection: "landscape" },
  162: { label: "수시 위험성평가", isApproval: false, usePrint: true, usePrevPost: true, printDirection: "landscape" },

  163: { label: "작업장 순회점검일지", isApproval: false, usePrint: true, hidePrintTitle: true },
  164: { label: "요양보호사", isApproval: true, usePrint: true },
  165: { label: "종사자 및 주차시설", isApproval: true, usePrint: true },
  166: { label: "냉온수기 및 보일러 설비", isApproval: true, usePrint: true },
  167: { label: "행사자 동선 및 관계자", isApproval: true, usePrint: true },
  168: { label: "시설물 관리(공통)", isApproval: true, usePrint: true },
  169: { label: "시설물 내부", isApproval: true, usePrint: true },

  170: { label: "시설물 외부 안전점검표", isApproval: true, usePrint: true },
  171: { label: "부대 시설 안전점검표", isApproval: true, usePrint: true },
  172: { label: "비상설비 안전점검표", isApproval: true, usePrint: true },
  173: { label: "소방용수 탱크 안전점검표", isApproval: true, usePrint: true },
  174: { label: "소방 및 신호기 안전점검표", isApproval: true, usePrint: true },
  175: { label: "주차시설 안전점검표", isApproval: true, usePrint: true },
  176: { label: "기둥, 벽, 보, 천장 안전점검표", isApproval: true, usePrint: true },
  177: { label: "전기시설 안전점검표", isApproval: true, usePrint: true },
  178: { label: "전기 외함 안전점검표", isApproval: true, usePrint: true },
  179: { label: "실외기 및 완강기 안전점검표", isApproval: true, usePrint: true },
  180: { label: "가지치기 안전점검표", isApproval: true, usePrint: true },
  181: { label: "진드기 및 질병예방 안전점검표", isApproval: true, usePrint: true },
  182: { label: "산불예방감시 안전점검표", isApproval: true, usePrint: true },
  183: { label: "풀베기 안전점검표", isApproval: true, usePrint: true },
  184: { label: "산불진화작업 안전점검표", isApproval: true, usePrint: true },
  185: { label: "청원경찰 안전점검표", isApproval: true, usePrint: true },
  186: { label: "청소차량 및 환경미화원 안전점검표", isApproval: true, usePrint: true },
  187: { label: "청소차량 안전점검표", isApproval: true, usePrint: true },
  188: { label: "근로자 건강관리(공통) 안전점검표", isApproval: true, usePrint: true },
  189: { label: "밀폐공간 작업 안전점검표", isApproval: true, usePrint: true },
  190: { label: "유해화학물질 작업 안전점검표", isApproval: true, usePrint: true },
  191: { label: "중량물 작업 시 안전점검 안전점검표", isApproval: true, usePrint: true },
  192: { label: "작업장 바닥 작업 안전점검표", isApproval: true, usePrint: true },
  193: { label: "외벽 청소 작업 안전점검표", isApproval: true, usePrint: true },
  194: { label: "쓰레기 수거 작업 안전점검표", isApproval: true, usePrint: true },
  195: { label: "화기·용접 작업 안전점검표", isApproval: true, usePrint: true },
  196: { label: "급식 점검표 안전점검표", isApproval: true, usePrint: true },
  197: { label: "응급조치 안전점검표", isApproval: true, usePrint: true },
  198: { label: "계절성 업무에 따른 관리대책 안전점검표", isApproval: true, usePrint: true },
  199: { label: "사다리 작업 안전점검표", isApproval: true, usePrint: true },
  200: { label: "근골격계 질환 안전점검표", isApproval: true, usePrint: true },
  201: { label: "안전보건교육 안전점검표", isApproval: true, usePrint: true },
  202: { label: "위험작업별 안전점검표", isApproval: true, usePrint: true },
  203: { label: "기계식 주차설비 작업 안전점검표", isApproval: true, usePrint: true },
  204: { label: "청소(미화) 점검표 안전점검표", isApproval: true, usePrint: true },
  205: { label: "복도 및 화장실청소 안전점검표", isApproval: true, usePrint: true },
  206: { label: "승강기 작업 안전점검표", isApproval: true, usePrint: true },
  207: { label: "전기작업 안전점검표", isApproval: true, usePrint: true },
  208: { label: "위험대비 매뉴얼 대응조치 점검표", isApproval: true, usePrint: true },
  209: { label: "작업장 합동점검 안전점검표", isApproval: true, usePrint: true },
  210: { label: "건설기계·장비별 안전점검표", isApproval: true, usePrint: true },
  211: { label: "예초기 작업 안전점검표", isApproval: true, usePrint: true },
  212: { label: "기계톱 작업 안전점검표", isApproval: true, usePrint: true },
  213: { label: "곤돌라 작업 안전점검표", isApproval: true, usePrint: true },
  214: { label: "지게차 안전점검표 안전점검표", isApproval: true, usePrint: true },

  216: { label: "떨어짐 안전점검표", isApproval: false, usePrint: true, hidePrintTitle: true },
  217: { label: "물체에 맞음 안전점검표", isApproval: false, usePrint: true, hidePrintTitle: true },
  218: { label: "무너짐 안전점검표", isApproval: false, usePrint: true, hidePrintTitle: true },
  219: { label: "(건설현장) 건설기계·장비별 안전점검표", isApproval: false, usePrint: true, hidePrintTitle: true },
  220: { label: "(건설현장) 위험작업별 안전점검표", isApproval: false, usePrint: true, hidePrintTitle: true },
  221: { label: "(건설현장) 공종별 안전점검표", isApproval: false, usePrint: true, hidePrintTitle: true },
  222: { label: "헬스장 안전점검표", isApproval: false, usePrint: true },
  223: { label: "실내체육관 안전점검표", isApproval: false, usePrint: true },
  224: { label: "다목적실 안전점검표", isApproval: false, usePrint: true },
  225: { label: "스트레칭실 안전점검표", isApproval: false, usePrint: true },
  226: { label: "다목적 체육관 안전점검표", isApproval: false, usePrint: true },
  227: { label: "샤워실 안전점검표", isApproval: false, usePrint: true },
  228: { label: "탈의실 안전점검표", isApproval: false, usePrint: true },
  229: { label: "보도 육교 안전점검표", isApproval: false, usePrint: true },
  230: { label: "보도 육교 승강기 안전점검표", isApproval: false, usePrint: true },
  231: { label: "제방 안전점검표", isApproval: false, usePrint: true },
  232: { label: "방파제 안전점검표", isApproval: false, usePrint: true },
  233: { label: "어린이집 안전점검표", isApproval: false, usePrint: true },

  234: { label: "시설물 진단", isApproval: true, usePrint: true },
  235: { label: "시설물 보수", isApproval: true, usePrint: true },
  236: { label: "시설물 보강", isApproval: true, usePrint: true },
  237: { label: "시설물 교체", isApproval: true, usePrint: true },

  238: { label: "(재해발생) 비상조치 및 처리 절차 안내", isApproval: false, usePrint: true },
  239: { label: "비상대피 훈련", isApproval: false, usePrint: true },
  240: { label: "비상대피 교육", isApproval: false, usePrint: true },
  241: { label: "비상대피 자체평가", isApproval: false, usePrint: true },
  242: { label: "비상조치계획 수립", isApproval: false, usePrint: true },
  243: { label: "관계수급인 안전보건 조치 확인 및 조정", isApproval: true, usePrint: true },

  244: { label: "중대재해 발생 보고", isApproval: false, usePrint: true, hidePrintTitle: true },
  245: { label: "사고발생 및 재발방지계획서", isApproval: true, usePrint: true },

  246: { label: "안전작업계획서(고위험작업)", isApproval: false, usePrint: true, hidePrintTitle: true, usePrevPost: true },
  247: { label: "위험작업", isApproval: true, usePrint: true },
  248: { label: "일반작업", isApproval: true, usePrint: true },
  249: { label: "기타작업", isApproval: true, usePrint: true },
  250: { label: "산업안전보건관리비", isApproval: false, usePrint: true, useHeaderDate: false },

  251: { label: "현장근로자 정보", isApproval: false, usePrint: true },
  252: { label: "환경보전비", isApproval: true, usePrint: true, useHeaderDate: true },
  253: { label: "아차사고 사례", isApproval: true, usePrint: true },
  254: { label: "아차사고 사례 개선 확인", isApproval: true, usePrint: true },
  255: { label: "아차사고 D/B", isApproval: true, usePrint: true },
  256: { label: "최초 위험성평가", isApproval: false, usePrint: true, usePrevPost: true, printDirection: "landscape" },
  257: { label: "작업허가서", isApproval: false, usePrint: true, hidePrintTitle: true, usePrevPost: true },
  258: { label: "안전작업계획서", isApproval: true, usePrint: true },
  259: { label: "안전 및 보건에 관한 협의체", isApproval: false, usePrint: true, hidePrintTitle: true, usePrevPost: true },
  260: { label: "노사협의체", isApproval: true, usePrint: true },
  261: { label: "일일 안전보고 일지", isApproval: false, usePrint: true, hidePrintTitle: true, useDelete: true, useHeaderDate: false, usePrevPost: true },
  262: { label: "노사협의체", isApproval: true, usePrint: true },
  263: { label: "노사협의체", isApproval: true, usePrint: true },
  264: { label: "노사협의체", isApproval: true, usePrint: true },
  265: { label: "노사협의체", isApproval: true, usePrint: true },
  266: { label: "안전작업계획서", isApproval: true, usePrint: true },
  267: { label: "안전작업계획서", isApproval: true, usePrint: true },
  268: { label: "안전작업계획서", isApproval: true, usePrint: true },
  269: { label: "안전작업계획서", isApproval: true, usePrint: true },
  270: { label: "안전작업계획서", isApproval: true, usePrint: true },
  271: { label: "안전작업계획서", isApproval: true, usePrint: true },
  272: { label: "안전작업계획서", isApproval: true, usePrint: true },
  273: { label: "안전작업계획서", isApproval: true, usePrint: true },
  274: { label: "안전작업계획서", isApproval: true, usePrint: true },
  275: { label: "안전작업계획서", isApproval: true, usePrint: true },
  276: { label: "안전작업계획서", isApproval: true, usePrint: true },
  277: { label: "안전작업계획서", isApproval: true, usePrint: true },
  278: { label: "안전작업계획서", isApproval: true, usePrint: true },
  279: { label: "안전작업계획서", isApproval: true, usePrint: true },
  280: { label: "안전작업계획서", isApproval: true, usePrint: true },
  281: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  282: { label: "관리감독자 선임", isApproval: false, usePrint: true, printLabel: "지정서 출력", hidePrintTitle: true },
  283: { label: "안전보건조정자 선임", isApproval: false, usePrint: true, printLabel: "지정서 출력" },
  284: { label: "관리책임자 안전보건 경영방침 작성", isApproval: false, usePrint: true, hidePrintTitle: true },
  285: { label: "안전보건관리(총괄)책임자 선임", isApproval: false, usePrint: true, printLabel: "지정서 출력", hidePrintTitle: true },
  286: { label: "업무수행평가표(안전보건관리총괄책임자용)", isApproval: false, usePrint: true, useHeaderDate: false },
  287: { label: "관리감독자 업무수행 평가표", isApproval: false, usePrint: true, useHeaderDate: false },
  288: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  289: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  290: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  291: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  292: { label: "[은평구청]근골격계 증상조사표", isApproval: true, usePrint: true, useHeaderDate: false },
  293: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  294: { label: "중대시민재해 이행사항 점검표 1", isApproval: false, usePrint: true, useHeaderDate: false },
  295: { label: "중대시민재해 이행사항 점검표 2", isApproval: false, usePrint: true, useHeaderDate: false },
  296: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  297: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  298: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  299: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  300: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  301: { label: "도급·용역·위탁 현장", isApproval: false, usePrint: true, useHeaderDate: false, hideFileDownload: true, byCurrentLocation: true },
  302: { label: "발주 현장", isApproval: false, usePrint: true, useHeaderDate: false, hideFileDownload: true, byCurrentLocation: true },
  303: { label: "시설물", isApproval: false, usePrint: true, useHeaderDate: false, hideFileDownload: true, byCurrentLocation: true },
  304: { label: "유관기관 비상연락망", isApproval: false, usePrint: true, useHeaderDate: false },
  305: { label: "안전검사 대상 기계·기구 종류 및 검사주기", isApproval: false, usePrint: true, useHeaderDate: false },
  306: { label: "근골격계부담작업", isApproval: false, usePrint: true, useHeaderDate: false },
  307: { label: "안전사고 발생 보고서", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },
  308: { label: "재발방지 조치 보고서", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },
  309: { label: "일반재해 산재업무 처리절차", isApproval: false, usePrint: true, useHeaderDate: false, hideFileDownload: true },
  310: { label: "중대재해 산재업무 처리절차", isApproval: false, usePrint: true, useHeaderDate: false, hideFileDownload: true },
  311: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  312: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  313: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  314: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  315: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  316: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  317: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  318: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  319: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  320: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  321: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  322: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  323: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  324: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  325: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  326: { label: "장마철(태풍)", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },
  327: { label: "동절기", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },
  328: { label: "해빙기", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },
  329: { label: "산업안전보건관리비(하도급업체)", isApproval: false, usePrint: true, useHeaderDate: false },
  330: { label: "안전 및 보건에 관한 협의체 위임장", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },
  331: { label: "안전개선 제안서", isApproval: false, usePrint: true, useHeaderDate: false },
  332: { label: "위험성평가 회의록", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },
  333: { label: "위험성평가 회의록", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },
  334: { label: "위험성평가 회의록", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },
  335: { label: "하도급업체 등록", isApproval: false, usePrint: true, hideFileDownload: true },
  336: { label: "본사(현장) ID 등록", isApproval: false, usePrint: true, hideFileDownload: true },
  345: { label: "중대재해 발생 보고(건설업)", isApproval: true, usePrint: true, hidePrintTitle: true },
  346: { label: "중대재해 발생 보고(제조업)", isApproval: true, usePrint: true, hidePrintTitle: true },
  391: { label: "안전보건 순회점검 보고서", isApproval: false, usePrint: true, hideFileDownload: false, hidePrintTitle: true },
  434: { label: "안전·보건 교육", isApproval: false, usePrint: true, useHeaderDate: false },
  392: { label: "우기대비 시설물 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  393: { label: "우기대비 시설물 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  394: { label: "해빙기 시설물 등 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  395: { label: "해빙기 시설물 등 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  396: { label: "근골격계 작업환경 개선 계획서", isApproval: false, usePrint: true, useHeaderDate: false },
  397: { label: "MSDS(Material Safety Data Sheet) 리스트 관리", usePrint: true },
  398: { label: "안전보건 일정표", usePrint: true, listType: "list398" },
  399: { label: "화학물질 관리대장", usePrint: true },
  400: { label: "화학물질(작업환경측정 대상) 취급대장", usePrint: true },
  401: { label: "안전작업계획서(장비작업)", usePrint: true },
  402: { label: "안전·보건 순회점검 결과서", isApproval: false, usePrint: true, useHeaderDate: false },

  433: { label: "종사자 정보", isApproval: false, usePrint: true, useHeaderDate: false },
  440: { label: "안전·보건관리자 및 산업보건의 선임", isApproval: false, usePrint: true, useHeaderDate: false },
  456: { label: "종사자 정보", isApproval: false, usePrint: true, useHeaderDate: false },
  475: { label: "3등급(상·중·하) 판단법", isApproval: false, usePrint: true },
  476: { label: "주간 이행사항 점검 및 회의", isApproval: false, usePrint: true },
  477: { label: "일일TBM 활동", isApproval: false, usePrint: true },
  491: { label: "안전관리자 선임보고서", isApproval: false, usePrint: true, hidePrintTitle: true, useHeaderDate: false, usePrevPost: false },
  492: { label: "비상사태훈련 결과보고서", isApproval: false, usePrint: true, hidePrintTitle: true },

  509: { label: "TBM 실행 체크리스트", isApproval: false, usePrint: true },
  510: { label: "TBM 실행 체크리스트", isApproval: false, usePrint: true },

  522: { label: "최초 위험성평가", isApproval: false, usePrint: true, printDirection: "landscape" },
  523: { label: "수시 위험성평가", isApproval: false, usePrint: true, printDirection: "landscape" },
  524: { label: "작업지휘자 지정서", isApproval: false, usePrint: true, hidePrintTitle: true,},
  525: { label: "유도원 및 신호수 지정", isApproval: false, usePrint: true },
  526: { label: "화재감시자 지정", isApproval: false, usePrint: true },
  527: { label: "안전보건 조직 체계도", isApproval: false, usePrint: true, hidePrintTitle: true },
  528: { label: "최초 TBM 회의록", detailLable:"Tool Box Meeting 회의록", isApproval: false, usePrint: true, hidePrintTitle: true },
  529: { label: "차량계 하역운반/건설기계 작업계획서", isApproval: false, usePrint: true },
  530: { label: "밀폐공간 점검 체크리스트", isApproval: false, usePrint: true },
  531: { label: "수시 TBM 회의록", detailLable:"Tool Box Meeting 회의록", isApproval: false, usePrint: true, hidePrintTitle: true },

  688: { label: "수급인 정보", isApproval: false, usePrint: true },

  846: { label: "밀폐공간 점검 체크리스트", isApproval: false, usePrint: true },
  847: { label: "화재감시자 지정", isApproval: false, usePrint: true },

  1049: { label: "최초 위험성평가(상·중·하)", isApproval: false, usePrint: true, useHeaderDate: true },
  1050: { label: "정기 위험성평가(상·중·하)", isApproval: false, usePrint: true, useHeaderDate: true },
  1051: { label: "수시 위험성평가(상·중·하)", isApproval: false, usePrint: true, useHeaderDate: true },
};
